import { createAsyncThunk } from "@reduxjs/toolkit";
import userAccessService from "../../../services/users/userAccessService";

export const getUserAccess = createAsyncThunk(
  "userAccess/getUserAccess",
  async (_, thunkAPI) => {
    try {
      return await userAccessService.getUserAccess();
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);
